// extracted by mini-css-extract-plugin
module.exports = {"solutionsDetail":"solutionsDetail_solutionsDetail__n9wTT"};